export const surfaceTypes = [
	{
		id: 'nonfoil',
		name: 'Non-foil'
	},
	{
		id: 'foil',
		name: 'Foil'
	}
];

export const conditions = [
	{
		id: 'NM',
		name: 'Near Mint'
	},
	{
		id: 'EX',
		name: 'Excellent'
	},
	{
		id: 'GD',
		name: 'Good'
	},
	{
		id: 'PL',
		name: 'Played'
	},
	{
		id: 'HP',
		name: 'Heavily Played'
	},
];

/**
*  Choose price from a given object of prices
*  @param type
*  @param condition
*  @param prices
*/
export function choosePrice (type, condition, count, prices) {
	let price;
	if(typeof prices === 'object' && condition && type) {
		price = prices[type][condition] * count;
		return price.toFixed(2);
	} else {
		return parseFloat(prices);
	}
};

/**
*  Get Surface Types
*  @param null
*/
export function getSurfaceTypes () {
	return surfaceTypes;
}

/**
*  Format price for print
*  @param price
*/
export function formatPrice(price) {
	if(price) {
		return "€" + price.toFixed(2);
	} else {
		return false;
	}
}

/**
*  Calculate total cart prices
*  @param items
*/
export function calculateTotalPrice(items) {
	if(items.length) {
		let total = 0;
		items.map((item) => {
			return total += parseFloat(choosePrice(item.version, item.condition, item.quantity, item.prices));
		});
		return total;
	} else {
		return '';
	}
}

/**
*  Calculate total cart amount of cards
*  @param items
*/
export function calculteTotalCardsAmount(items) {
	if(items.length) {
		let total = 0;
		items.map((item) => {
			return total += item.quantity;
		});
		return total;
	} else {
		return '';
	}
}

/**
*  Checks if there's any single card's quantity than specified amount
*  @param cards
*  @param limit
*/
export function isThereAnyCardUpToLimit(cards, limit) {
	for (var i = 0; i < cards.length; i++) {
		if(cards[i].quantity >= limit) {
			return true;
		}
	}
	return false;
}

/**
*	Complicated way of checking card quantities
*	@param cards
*	@param limit
*/
export function areThereAnyCardsUpTolimit(cards, limit) {
	for (var i = 0; i < cards.length; i++) {
		let cardId = cards[i].cardId;
		let cardVersion = cards[i].version;
		let cardCondition = cards[i].condition;
		let quantity = 0;
		for (var z = 0; z < cards.length; z++) {
			if(cards[z].cardId === cardId && cards[z].version === cardVersion && cards[z].condition === cardCondition) {
				quantity += cards[z].quantity;
			}
		}
		if(quantity >= limit) {
			return true;
		}
	}
	return false;
}

/**
*  Get expansion icon positions
*  @param id
*/
export function getExpansionIconStyles(id) {
	let rows = (Math.round(parseInt(id / 10,10)) * 10)/10;
	let columns = id % 10;
	let x_position = -21 * columns;
	let y_position = -21 * rows;
	return {
		backgroundPosition: x_position+'px '+y_position+'px'
	}
}

/**
 *	Sets date of last update of Cart
 *	@param null
 */
export function setCartDateUpdated() {
	let date = new Date().getTime();
	try {
		localStorage.setItem('cartUpdated', date);
		return true;
	} catch (error) {
	}
}


/**
 *	Checks whether date now is older than last update of cart
 *	@param hours
 */
export function isCartOutdated(hours) {
	let now = new Date().getTime();
	const oneHour = (60 * 60 * 1000);
	try {
		let cartUpdatedAt = localStorage.getItem('cartUpdated') ? localStorage.getItem('cartUpdated') : (new Date() - (oneHour * hours * 2));
		if((now - cartUpdatedAt) > (oneHour * hours)) {
			return true;
		} else {
			return false;
		}
	} catch (error) {
	}
}



/** WEBPACK FOOTER **
 ** ./src/utils/cartHelper.js
 **/